import { OutlookEventDispId, unregisterApiEvent } from 'owa-addins-events';
import {
    getExtensibilityState,
    hideSsoDialog,
    InvokeAppAddinCommandStatusCode,
    terminateUilessAddinCommand,
} from 'owa-addins-store';

const unregisterDialogBeforeTermination = function(controlId: string): void {
    if (
        getExtensibilityState().activeDialog &&
        getExtensibilityState().activeDialog.parentControlId == controlId
    ) {
        unregisterApiEvent({
            eventDispId: OutlookEventDispId.DISPLAY_DIALOG_DISPID,
            controlId: controlId,
        });
    }

    hideSsoDialog(controlId);
};

export default function closeUILessAddinCommand(
    controlId: string,
    hostItemIndex: string,
    status: InvokeAppAddinCommandStatusCode
) {
    unregisterDialogBeforeTermination(controlId);
    terminateUilessAddinCommand(controlId, hostItemIndex, status);
}
